import AppointmentNote from './AppointmentNote';

export default AppointmentNote;
